import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';

import immutableToJS from 'helpers/immutableToJS';
import { getSelector } from 'redux/selectors';

class PaginationComponent extends Component {
  static propTypes = {
    pagination: PropTypes.node,
  };

  static defaultProps = {
    pagination: null,
  };

  render() {
    const { pagination } = this.props;
    if (!pagination) return null;
    return (
      <div className="static-component">
        {pagination}
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  pagination: getSelector('ui', 'pagination')(state),
});

export default compose(
  setDisplayName('PaginationComponent'),
  connect(mapStateToProps),
  immutableToJS,
)(PaginationComponent);
